import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 5C4 3.34315 5.34315 2 7 2H12.1716C12.9672 2 13.7303 2.31607 14.2929 2.87868L13.9583 3.21328L14.2929 2.87868L19.1213 7.70711C19.6839 8.26972 20 9.03278 20 9.82843V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM12 4H7C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V10H15C13.3431 10 12 8.65685 12 7V4ZM16.5858 8H15C14.4477 8 14 7.55228 14 7V5.41421L16.5858 8Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }